const API_DIRECTORY_THEME = {
  DEALER_API_DIRECTORY: 'dealerApiDirectory',
  ISV_API_DIRECTORY: 'isvApiDirectory'
};

const SEARCH_FILTER_URL_PARAMS = {
  filters: 'Group',
  apiType: 'Type',
  category: 'Category'
};
const API_TYPES = {
  REST: 'api',
  ASYNC: 'async-api',
  PROVIDER_ID_PREFIX: 'api-v2'
};
const APP_STATUS = {
  CANCELLED: 'Cancelled'
};

const API_DETAILS_HANDLERS_MODEL = {
  apiTypeFilter: type => {
    alert(JSON.stringify(type));
  },
  apiCategoryFilter: category => {
    alert(JSON.stringify(category));
  },
  sendEmailToConsumer: payload => {
    alert(JSON.stringify(payload));
  },
  sendEmailToProvider: payload => {
    alert(JSON.stringify(payload));
  },
  addToCart: apiDetails => {
    alert(JSON.stringify(apiDetails));
  },
  buildWithApi: apiDetails => {
    alert(JSON.stringify(apiDetails));
  },
  openMyCart: () => {},
  viewInMyAPIs: () => {},
  handleRequestAccess: apiDetails => {
    alert(JSON.stringify(apiDetails));
  }
};

const API_DIR_HOME_HANDLERS_MODEL = {
  addApiToCart: payload => {
    return payload;
  },
  handleApiRedirection: payload => {
    return payload;
  },
  handleBundleRedirection: payload => {
    return payload;
  },
  handleUrlparams: payload => {
    return payload;
  },
  openMyCart: () => {},
  viewInMyAPIs: apiDetails => {}
};
const FORTELLIS_BOT_HELLO_MESSAGE =
  "I'm AIVA. I can answer questions you have about Fortellis.";

export {
  API_DIRECTORY_THEME,
  API_TYPES,
  API_DETAILS_HANDLERS_MODEL,
  API_DIR_HOME_HANDLERS_MODEL,
  SEARCH_FILTER_URL_PARAMS,
  APP_STATUS,
  FORTELLIS_BOT_HELLO_MESSAGE
};
